__turbopack_context__.v({
  "extra_link_bg": "navbar-module__zdcNmq__extra_link_bg",
  "mobile_nav_holder": "navbar-module__zdcNmq__mobile_nav_holder",
});
